import React from 'react';
import { ArrowRightIcon, StarIcon, ShieldCheckIcon, UsersIcon, MapPinIcon, LockIcon } from 'lucide-react';
import { MOCKUP_URL } from '../data/content';
export function Hero() {
  const chips = ['PDF Digital', 'Acceso Inmediato', 'Familias con Chicos'];
  const proof = [{
    icon: ShieldCheckIcon,
    label: 'Garantía 7 días'
  }, {
    icon: LockIcon,
    label: 'Pago seguro Mercado Pago'
  }, {
    icon: UsersIcon,
    label: '+500 Familias'
  }, {
    icon: StarIcon,
    label: '4.9 Rating'
  }, {
    icon: MapPinIcon,
    label: 'Todo Argentina'
  }];
  return <header data-id="element-118" data-mp="x8b85pz4fd3w">
      <div className="mx-auto flex max-w-4xl flex-col items-center px-4 pb-12 pt-8 text-center md:px-5 md:pb-20 md:pt-14" data-id="element-119" data-mp="x8jojrugd0ju">
        <p className="font-display text-sm font-semibold text-pumpkin md:text-lg" data-id="element-120" data-mp="ncq0bb7dfim8">
          Megapack Halloween Fiestas 6+3 <span className="text-mist" data-id="element-121" data-mp="3d1s9sv56tfs2">· Tomos + Extras</span>
        </p>
        <h1 className="mt-2 font-display text-[2.4rem] font-bold leading-[1.02] tracking-tight text-bone sm:text-6xl md:mt-3 lg:text-7xl" data-id="element-122" data-mp="382p5xe0y1flo">
          Todo tu Halloween familiar resuelto en <span className="text-pumpkin" data-id="element-123" data-mp="3j6obhix6kkpk">un solo lugar</span>
        </h1>

        <figure className="mt-6 w-[70%] max-w-[30rem] md:mt-8" data-id="element-124" data-mp="3o73pmcpadw8l">
          <div className="aspect-square w-full overflow-hidden rounded-2xl bg-dusk ring-1 ring-line md:rounded-3xl" data-id="element-125" data-mp="39b4ip5dwy251">
            <img src={MOCKUP_URL} alt="Los 11 tomos del Megapack de Halloween en PDF: decoración, disfraces, mesa dulce, juegos, leyendas, maquillaje, extras y tomos premium" width={1254} height={1254} loading="eager" decoding="async" {...{
            fetchpriority: 'high'
          }} sizes="(min-width: 768px) 480px, 70vw" className="block h-full w-full object-contain" data-id="element-126" data-mp="3e84orgarj4w5" />
          </div>
          <figcaption className="mt-2.5 flex items-center justify-center gap-2" data-id="element-127" data-mp="2hkgl23bg7ew4">
            <span className="flex items-center gap-0.5 text-pumpkin" aria-hidden="true" data-id="element-128" data-mp="2ljpaivzggqlv">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-129" data-mp="s3uqvwnx98am" data-mpi={i} />)}
            </span>
            <span className="text-xs font-semibold text-bone md:text-sm" data-id="element-130" data-mp="n9i3jbjbrctl">4.9 · +500 familias</span>
          </figcaption>
        </figure>

        <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-mist md:mt-7 md:text-lg" data-id="element-131" data-mp="ddwxn2b4xsek">
          Tu fiesta de Halloween completa lista: decoración, disfraces, juegos, mesa dulce, maquillaje y leyendas de terror. Sin que la diversión se apague en ningún momento.
        </p>

        <ul className="mt-4 flex flex-wrap justify-center gap-1.5 md:gap-2" data-id="element-132" data-mp="1126polyxzce5">
          {chips.map(c => <li key={c} className="rounded-full bg-plum px-2.5 py-1 text-xs font-semibold text-bone ring-1 ring-line md:px-3 md:text-sm" data-id="element-133" data-mp="x1w80c1sexjg">
              {c}
            </li>)}
        </ul>

        <a href="#precios" className="group mt-6 inline-flex w-full items-center justify-center gap-3 whitespace-nowrap rounded-2xl bg-pumpkin px-4 py-3.5 font-display text-sm font-bold text-night shadow-[0_6px_0_0_#b34d00] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-pumpkin-soft active:translate-y-1 active:shadow-[0_2px_0_0_#b34d00] focus:outline-none focus-visible:ring-4 focus-visible:ring-pumpkin/40 sm:w-auto sm:px-7 sm:py-4 sm:text-lg md:mt-8" data-id="element-134" data-mp="3hr3tc077qj7x">
          QUIERO MI HALLOWEEN RESUELTO AHORA
          <ArrowRightIcon className="hidden h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-0.5 sm:block" aria-hidden="true" data-id="element-135" data-mp="2g2566qxfmsxs" />
        </a>

        <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-mist md:mt-7 md:gap-x-5 md:text-sm" data-id="element-136" data-mp="2p10dk6c7q92o">
          {proof.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-137" data-mp="unj1bfh9cymy">
              <Icon className="h-4 w-4 text-pumpkin-soft" aria-hidden="true" data-id="element-138" data-mp="zl12gjp1a9ke" />
              {label}
            </li>)}
        </ul>
      </div>
    </header>;
}